<template>
  <basic-container>
    <el-dialog
      title="打印预览"
      :visible.sync="payChargePrintPreShowDialogFlag"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
    >
      <div class="el-property-dialog-div">
        <avue-form
          v-if="payChargePrintPreShowDialogFlag"
          v-model="payChargePrintPreForm"
          :option="payChargePrintPreOption"
          ref="payChargePrintPreFormRef"
          @submit="printSave"
          @click="saveF5"
        >

                <template slot="formHead">
                  <div>
                    <el-row style="text-align:right;">
                      <el-col :span="24">票据号: <el-input v-model="payChargePrintPreForm.invoiceNo" style="width:9rem;"></el-input></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">客户:{{payChargePrintPreForm.payManName}}</el-col>
                      <el-col :span="6">房间:{{payChargePrintPreForm.targetName}}</el-col>
                      <el-col :span="6">结算方式:{{payChargePrintPreForm.payTypeName}}</el-col>
                      <el-col :span="6">收款时间:{{payChargePrintPreForm.payTime}}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">项目名称:{{payChargePrintPreForm.communityName}}</el-col>
                    </el-row>
                  </div>
                </template>
                <template slot="detailList">
                  <div>
                        <!-- v-if="showAuthCodeFlag" -->
                        <el-table :data="payChargePrintPreForm.detailsList">
                          <el-table-column
                            prop="subjectName"
                            label="收费科目"></el-table-column>
                                  <el-table-column
                            prop="startDate"
                            label="起始日期"></el-table-column>
                                  <el-table-column
                            prop="endDate"
                            label="截止日期"></el-table-column>
                                  <!-- <el-table-column
                            prop="payPrice"
                            label="单价"></el-table-column>
                                  <el-table-column
                            prop="payPrice"
                            label="数量"></el-table-column> -->
                                  <el-table-column
                            prop="shouldAmount"
                            label="应收金额"></el-table-column>
                                  <el-table-column
                            prop="derateAmount"
                            label="减免金额"></el-table-column>
                                  <el-table-column
                            prop="payAmount"
                            label="实收金额"></el-table-column>
                        </el-table>
                        <div style="height:1rem;"></div>
                        <el-row>
                          <el-col :span="2">
                            收款备注
                          </el-col>
                          <el-col :span="22">
                            <el-input type="textarea" placeholder="收款备注" v-model="payChargePrintPreForm.description" disabled></el-input>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="6">收款金额合计：{{payChargePrintPreForm.totalShouldAmount}}</el-col>
                          <el-col :span="6">收款人：{{payChargePrintPreForm.cashierName}}</el-col>
                        </el-row>
                    </div>
                </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button type="danger" @click="print('fast')">确认打印</el-button>
            <!--<el-button type="primary" @click="printSave">保存</el-button>-->
            <!-- <el-button type="danger" @click="print('rule')">打印</el-button> -->
            <!-- <el-button type="danger" @click="print('fast')">一键打印</el-button> -->
            <!--<el-button type="danger" @click="printElecBill">电子票据打印</el-button>-->
          </template>
        </avue-form>
      </div>
      <el-dialog
        title="电子票据"
        :visible.sync="pdfDialogFlag"
        width="50%"
        @closed="handlePdfClose"
        append-to-body
      >
        <iframe width="100%" height="700" :src="printPdfUrl"></iframe>
      </el-dialog>
    </el-dialog>
  </basic-container>
</template>

<script>
import { checkPayBillNo, billPrint } from '@/api/charge/index';
import { billPrintPervNew, billPrintSaveNew, billPrintUpdateNew, checkPayBillNoNew } from '@/api/charge/charge-pay';
import payChargePrintPreOption from './printdialog-option';
import urlSettings from '@/config/url-settings.js';
export default {
  data() {
    return {
      printPdfUrl: '',
      pdfDialogFlag: false,
      payChargePrintPreShowDialogFlag: false,
      payChargePrintPreForm: {},
      payChargePrintPreOption: payChargePrintPreOption,
      invoiceNo: '',
      printTimes: '',
      payBillNo: '',
      payId:'',
      printFlag:true,
    };
  },
  computed: {},
  methods: {
    openPayChargePrintPreDialog(payBillNo) {
      this.payBillNo = payBillNo;
      billPrintPervNew({ payNo: payBillNo }).then(({ data }) => {
        this.payChargePrintPreForm = data;
        this.invoiceNo = data.invoiceNo;
        this.payId = data.id;
        // var text = this.findObject(this.payChargePrintPreOption.column, 'invoiceNo');
        // if (this.invoiceNo) {
        //   text.disabled = true;
        // } else {
        //   text.disabled = false;
        // }
        this.printTimes = data.printTimes;
      });
      this.payChargePrintPreShowDialogFlag = true;
    },
    saveF5() {
      this.$emit('saveF5');
    },
    //打印保存
    printSave(form, done) {
      if(!this.payChargePrintPreForm.invoiceNo){
        this.$message.error('票据号不能为空!');
        done();
        return;
      }
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          billPrintSaveNew({invoiceNo:form.invoiceNo,id:this.payId}).then(
            () => {
              this.$message.success('操作成功!');
              // var text = this.findObject(this.payChargePrintPreOption.column, 'invoiceNo');
              // text.disabled = true;
              done();

              this.$emit('saveF5');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    resetPrintForm(){
        this.payChargePrintPreShowDialogFlag = false;
        setTimeout(()=>{
          this.payChargePrintPreShowDialogFlag = true;
        });
    },
    //打印
    print(type) {

      //打印开关 避免重复提交
      if(!this.printFlag){
        return;
      }
      this.printFlag = false;
      if(!this.payChargePrintPreForm.invoiceNo){
        this.$message.error('票据号不能为空!');
              this.printFlag = true;
        return;
      }
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          console.log("this.payChargePrintPreForm====>",this.payChargePrintPreForm);
          checkPayBillNoNew({invoiceNo:this.payChargePrintPreForm.invoiceNo,id:this.payId}).then(
            () => {
              //打印更新数据
              billPrintUpdateNew(this.payChargePrintPreForm).then(
                () => {
                  //票据号未被使用过，打开cpt页面
                  if(type=='fast'){
                    this.openPrintWindow('fast');
                  }else{
                    this.openPrintWindow('rule');
                  }

                  this.printTimes++;
                  this.resetPrintForm();
                },
                (error) => {
                  console.log(error);
                  this.printFlag = true;
                  this.resetPrintForm();
                }
              );
            },
            (error) => {
              this.printFlag = true;
              this.resetPrintForm();
              console.log(error);
            }
          );
        }else{
          this.printFlag = true;
        }
      });
    },
    //电子票据打印
    printElecBill() {
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          checkPayBillNo(this.payChargePrintPreForm).then(
            () => {
              //打印更新数据
              billPrint(this.payChargePrintPreForm).then(
                ({ data }) => {
                  this.pdfDialogFlag = true;
                  this.printPdfUrl = location.origin + '/pdfjs/web/viewer.html?file=' + data;
                  debugger;
                },
                (error) => {
                  console.log(error);
                }
              );
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    //打开cpt页面
    openPrintWindow(type) {
      //打印次数
      let printTimes = this.printTimes + 1;
      //票据号
      let payBillNo = this.payBillNo;

      //跳转帆软html处理页面地址 并把票据号传到页面上
      let path = '';
      if(type=='fast'){
         if (printTimes > '0') {
        this.$message({
            message: '已打印[' + printTimes + ']次',
            type: 'warning'
        });
        setTimeout(()=>{
          this.printFlag = true;
        },1000)
      } else {
        this.printFlag = true;
      }
        // path = urlSettings.VUE_APP_BASE_REPORT_URL.split('ReportServer?')[0]  +'html/printbill.html?payBillNo='  + payBillNo + '&reportUrl='+ urlSettings.VUE_APP_REPORT_ENVIRONMENT;
        path = 'http://localhost:8075/WebReport/ReportServer?reportlet=newbill2.cpt&op=write'
        // path = urlSettings.VUE_APP_BASE_REPORT_URL + urlSettings.VUE_APP_ENVIRONMENT + '/fastNewbill.cpt&op=write&payBillNo='+payBillNo;
        // path = 'http://192.168.99.214:8075/WebReport/ReportServer?reportlet=newbillreceipt.cpt&op=write'
        path = urlSettings.VUE_APP_BASE_REPORT_URL + urlSettings.VUE_APP_ENVIRONMENT + '/newbillreceipt.cpt&op=write'
        +'&payId='+this.payId
        +'&targetName='+this.payChargePrintPreForm.targetName
        +'&communityName='+this.payChargePrintPreForm.communityName
        +'&payTypeName='+this.payChargePrintPreForm.payTypeName
        +'&cashierName='+this.payChargePrintPreForm.cashierName
        +'&invoiceNo='+this.payChargePrintPreForm.invoiceNo
        window.open(
          path,
          'newindow',
          'height=600,width=1100,top=100,left=100,toolbar=no,' +
            'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
        );

      }else{
        path = urlSettings.VUE_APP_BASE_REPORT_URL.split('ReportServer?')[0]  +'html/printbill.html?payBillNo='  + payBillNo + '&reportUrl='+ urlSettings.VUE_APP_REPORT_ENVIRONMENT;
         if (printTimes > '0') {
          this.$message({
              message: '已打印[' + printTimes + ']次',
              type: 'warning'
          });
          setTimeout(()=>{
            this.printFlag = true;
            window.open(path);
          },1000)
        } else {
          this.printFlag = true;
          window.open(path);
        }
      }

      //票据号
      // let path = urlSettings.BASE_REPORT_URL + cptName + '&op=write&payBillNo=' + payBillNo;

      // 不再让用户点击确定 直接展示已打印多少次


    },
    handleClose() {
      this.$refs.payChargePrintPreFormRef.resetForm();
    },
    handlePdfClose() {
      this.$refs.payChargePrintPreFormRef.resetForm();
      this.payChargePrintPreShowDialogFlag = false;
      this.printPdfUrl = '';
    },
  },
};
</script>

